import React, { useEffect, useState } from 'react';
import { Modal, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import { customStyle } from '../Components/Style';
import "../Assets/Css/Department.scss";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
const initialState = {
    title: null,
};

const DepartmentTypes = [
    { value: 'Design', label: 'Design' },
    { value: 'Development', label: 'Development' },
    { value: 'Intern', label: 'Intern' },
    { value: 'Full Stack Developer', label: 'Full Stack Developer' },
    { value: 'Frontend Developer', label: 'Frontend Developer' },
    { value: 'Backend Developer', label: 'Backend Developer' },
    { value: 'Team Leader', label: 'Team Leader' },
    { value: 'HR', label: 'HR' },
];

function AddDepartmentModal({ isModalVisible, closeModal, addDepartment, loading, departmentData, updateDepartment , designations = [],departments=[]})  {


    const [parent_department, setParentDepartment] = useState(null);
    const [name, setName] = useState('');
    const [selectedDesignations, setSelectedDesignations] = useState([]);
       const designationOptions = designations.map(designation => ({
        value: designation.id || designation.name,
        label: designation.name
    }));
     const departmentOptions = departments.map(department => ({
        value: department.name,
        label: department.name
    }));
    
    useEffect(() => {
        if (isModalVisible && departments.length > 0) {
             const departmentOptions = departments.map(department => ({
            value: department.name,
            label: department.name
        }));

            if (departmentData) {
                setName(departmentData?.name || '');

                       const parentDept = departmentOptions.find(dept => 
                dept.value === departmentData?.parent_department
            );
            setParentDepartment(parentDept || null);

                 const deptDesignations = departmentData?.designations?.map(d => ({
                    value: d.id || d.name,
                    label: d.name
                })) || [];
                setSelectedDesignations(deptDesignations);
            }
            else {
                setName('');
                setParentDepartment(null);
                setSelectedDesignations([]);
            }
        }
    }, [isModalVisible, departmentData,designations,departments]);

 
    const handleSave = async () => {
        if(!name) {
            toast.error('Please fill all required fields');
            return;
        }
        try {
            let body = {
                name,
                parent_department: parent_department?.label || null,
                designations: selectedDesignations.map(d => d.value)
            }
            if (departmentData) {
                await updateDepartment(departmentData?.id, body);
            }
            else {
                await addDepartment(body);
            }
            setName('')
            setParentDepartment(null)
            closeModal()
        } catch (error) {
            console.error("Error adding department:", error);
        }
    }

    const handleModalClose = () => {
        setName('');
        setParentDepartment(null);
        setSelectedDesignations([])
        closeModal();
    };
    return (
        <Modal show={isModalVisible} onHide={handleModalClose} size="lg" aria-labelledby="contained-modal-title-vcenter" centered className="custom-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className='heading'>{departmentData ? "Edit" : "Add"} Department</h5>
                    <button className="btn-close" onClick={closeModal}></button>
                </div>
                <div className="modal-body">
                    <div className='add-department-container'>
                        <div className='add-information-part'>
                            <div className='form-part'>
                                <form>
                                    <div className="form-group">
                                        <div className='row'>
                                            <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Name <span className='required-field'> *</span></h6>
                                                    <input type="text" className="input-css" name='departmentname' value={name} onChange={(e) => setName(e.target.value)} placeholder='ex: Frontend Developer' />
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Parent Department</h6>
                                                   <Select
                                                    options={departmentOptions}
                                                    styles={{
                                                        ...customStyle,
                                                        menu: (provided) => ({
                                                            ...provided,
                                                            zIndex: 2,
                                                        }),
                                                    }}
                                                   value={parent_department}
                                                    placeholder="Select Parent Department"
                                                   onChange={(val) => setParentDepartment(val || null)}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                     isClearable
                                                />
                                                    {/* <Select
                                                        options={Employees}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={parent_department}
                                                        placeholder="---"
                                                        onChange={(val) => {
                                                            setParentDepartment(val);
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    /> */}
                                                </div>
                                            </div>
                                          <div className="col-lg-6">
                                                <div className="input-group">
                                                    <h6 className='label'>Designations</h6>
                                                    <Select
                                                        options={designationOptions}
                                                        styles={{
                                                            ...customStyle,
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 2,
                                                            }),
                                                        }}
                                                        value={selectedDesignations}
                                                        placeholder="Select Designations"
                                                        isMulti 
                                                        onChange={(selectedOptions) => {
                                                            setSelectedDesignations(selectedOptions || []);
                                                        }}
                                                        theme={(theme) => ({
                                                            ...theme,
                                                            colors: {
                                                                ...theme.colors,
                                                                primary25: "#5757fe",
                                                                primary: "#5757fe",
                                                            },
                                                        })}
                                                    />
                                                </div>
                                            </div>
  
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer d-flex justify-content-start">
                    <button className="btn-save" onClick={handleSave}>
                        {loading ? <Spinner as="span" animation="border" role="status" aria-hidden="true" /> : "Save"}
                    </button>
                    <button className="btn-cancel" onClick={closeModal}>
                        Cancel
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default AddDepartmentModal;
